import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import CreditWallet from "./credit-wallet";
import {setWorkspaceGraphCreditWallets, upsertWorkspaceCreditWallet, workspaceGraphSelectors} from "../../system/workspace-graph-slice";

export function useCreditWallet() {
    const dispatch = useDispatch();
    const creditWallets = useSelector(workspaceGraphSelectors.creditWallets);

    const getCreditWallets = useCallback(async (workspaceId) => {
        if (!workspaceId) return [];
        const model = new CreditWallet();
        const data = await model.getAll({populate: "*"});
        const items = data?.data || [];
        dispatch(setWorkspaceGraphCreditWallets(items));
        return items;
    }, [dispatch]);
    const getCreditWallet = async (documentId) => {
        const model = new CreditWallet();
        const data = await model.getById(documentId);
        if (data?.data) dispatch(upsertWorkspaceCreditWallet(data.data));
        return data?.data;
    };
    const ensureCreditWallet = useCallback(async () => {
        const model = new CreditWallet();
        const data = await model.ensureMine();
        if (data?.data) dispatch(upsertWorkspaceCreditWallet(data.data));
        return data?.data || null;
    }, [dispatch]);
    return {creditWallets, getCreditWallets, getCreditWallet, ensureCreditWallet};
}
